/**
 * Development Environment Banner
 * Shows an orange banner when running in development mode
 * to prevent accidental confusion with production
 */
export default function DevBanner() {
  const envName = import.meta.env.VITE_ENV_NAME;
  const projectId = import.meta.env.VITE_FIREBASE_PROJECT_ID;

  // Only show in development
  if (envName !== 'DEVELOPMENT') {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-orange-500 text-white text-center py-1 text-sm font-semibold">
      <span className="inline-flex items-center gap-2">
        <span className="animate-pulse">DEV</span>
        <span className="text-orange-200">|</span>
        <span className="text-orange-100 font-normal">{projectId}</span>
      </span>
    </div>
  );
}
